<template>
  <div class="download-container f-2-cl" :style="mainBg">
    <div class="download-options c-5-bd">
      <!-- 新下载模块 -->
      <div class="download_main" :class="[$store.state.baseData.lan==='zh_CN'?'zh':'en',resource==='apple'?'apple':'android']">
        <div class="download_img_box">
          <div class="qrcode">
            <div v-show="resource==='apple'" id="qrcode"></div>
            <div v-show="resource==='android'" id="qrcode_android"></div>
          </div>
        </div>
        <div class="download_btns_box">
          <div class="download_btn" @click="linkAppstore">

            <img v-if="resource==='apple'" src="@/assets/images/1/iOS.png" alt="">
            <img v-else src="@/assets/images/1/android.png" alt="">
            <div class="btn_dec">
              <p>{{resource==='apple'?$t('appDownLoad.text6'):$t('appDownLoad.text1')}}</p>
              <span>{{resource==='apple'?$t('appDownLoad.text7'):$t('appDownLoad.text2')}}</span>
            </div>
          </div>
          <div class="download_btn" @click="linkGoogle">
            <img v-if="resource==='apple'" src="@/assets/images/1/iOS.png" alt="">
            <img v-else src="@/assets/images/1/google.png" alt="">
            <div class="btn_dec">
              <p>{{resource==='apple'?$t('appDownLoad.text8'):$t('appDownLoad.text3')}}</p>
              <span>{{resource==='apple'?$t('appDownLoad.text9'):$t('appDownLoad.text4')}}</span>
              <img v-if="resource==='apple'" class="apple_btn" src="@/assets/images/1/apple_btn.png" alt="">
              <img v-else src="@/assets/images/1/download_btn.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <!-- 新下载模块 -->
      <!-- 新安卓下载 -->
      <!-- <div class="download_main" :class="$store.state.baseData.lan==='zh_CN'?'zh':'en'">
        <div class="download_item">
          <div class="download_item_top">
            <img v-if="resource==='apple'" :class="resource==='apple'?'apple_logo':''" src="@/assets/images/1/apple.png" alt="">
            <img v-else src="@/assets/images/1/android.png" alt="">
            <div class="download_item_top_text" :class="resource==='apple'?'apple':'android'">
              <span>{{resource==='apple'?$t('appDownLoad.text6'):$t('appDownLoad.text1')}}</span>
              <p>{{resource==='apple'?$t('appDownLoad.text7'):$t('appDownLoad.text2')}}</p>
            </div>
          </div>
          <div class="download_item_qr" id="qrcode">

          </div>
        </div>
        <div class="download_item">
          <div class="download_item_top">
            <img v-if="resource==='apple'" src="@/assets/images/1/apple.png" alt="">
            <img v-else src="@/assets/images/1/google.png" alt="">
            <div class="download_item_top_text" :class="resource==='apple'?'apple':'android'">
              <span>{{resource==='apple'?$t('appDownLoad.text8'):$t('appDownLoad.text3')}}</span>
              <p>{{resource==='apple'?$t('appDownLoad.text9'):$t('appDownLoad.text4')}}</p>
            </div>
          </div>
          <div class="download_item_qr link_box" @click="linkGoogle">
            <div class="qr_dec">{{resource==='apple'?$t('appDownLoad.text10'):$t('appDownLoad.text5')}}</div>
            <img v-if="resource==='apple'" class="qr_icon qr_icon_apple" src="@/assets/images/1/next.png" alt="">
            <img v-else class="qr_icon" src="@/assets/images/1/download.png" alt="">
          </div>
        </div>
      </div> -->

      <!-- 新安卓下载 -->


      <!-- <div class="download-options-logo" v-if="flag">
        <img :src="appDownload.logo" alt="">
      </div>
      <p class="download-options-name f-8-cl">
        {{ $t('appDownLoad.title') }}
      </p> -->
      <!-- 随时随地 多平台终端交易 -->
      <!-- <p class="download-options-text">{{ $t('appDownLoad.desc') }}</p>
      <div class="download-options-buttons" style="display: none;">
        <c-button className="download-button"
          @click="download('ios_ipa')">
          <svg class="icon icon-18" aria-hidden="true">
            <use xlink:href="#icon-b_13"></use>
          </svg>
          &nbsp;
          {{$t('appDownLoad.platform')[0]}}
        </c-button>
        <c-button className="download-button"
          @click="download('android')">
          <svg class="icon icon-18" aria-hidden="true">
            <use xlink:href="#icon-b_14"></use>
          </svg>
          &nbsp;
          {{$t('appDownLoad.platform')[1]}}
        </c-button>
      </div> -->
      <!-- <div class="download-options-rq" id="qrcode"> -->
        <!-- <img :src="appDownload.app_page_url" alt=""> -->
      <!-- </div> -->
      <!-- 扫描二维码下载 -->
      <!-- <p class="download-options-reText">
        {{ $t('appDownLoad.twoDimension') }}
      </p> -->
    </div>
    <div class="download-nav c-5-bd">
      <ul class="download-nav-list clearfix">
        <li v-for="(item, index) in navList"
          :key="index"
          class="download-nav-even clearfix">
          <img :src="item.url" alt=""
            class="download-nav-img">
          <div class="download-nav-mode">
            <p class="download-nav-title f-1-cl">{{item.title}}</p>
            <p class="download-nav-text">{{item.desc}}</p>
          </div>
        </li>
      </ul>
    </div>
    <!-- <div class="download-step" v-show="resource==='apple'">
      iOS 用户安装教程
      <p class="download-step-title f-1-cl">{{ $t('appDownLoad.setUp.title') }}</p>
      <ul class="download-step-list">
        <li v-for="(item, index) in stepList"
          :key="index"
          class="download-step-even">
          <div class="download-step-label c-5-bd">{{ item.step }}</div>
          <div class="download-step-mode">
            <p class="download-step-h f-1-cl">{{ item.title }}</p>
            <p class="download-step-t">{{ item.desc }}</p>
            <div class="download-step-qr" v-if="index===stepList.length-1" >
              <div id="qrcode_tf"></div>
            </div>
          </div>
          <div class="download-step-img">
            <img :src="item.url" alt="">
          </div>
        </li>
      </ul>
    </div> -->
  </div>
</template>

<script>
import mixin from 'BlockChain-ui-privatization/PC/common-mixin/appDownload/appDownload';
import 'BlockChain-ui-privatization/PC/common-mixin/appDownload/appDownload.styl';

export default {
  mixins: [mixin],
  mounted() {
    this.init();
  },
  watch: {
    $route: {
      handler(n) {
        this.resource = n.name === 'install' ? 'apple' : 'android';
      },
      immediate: true,
    },
  },
  computed: {
  },
};
</script>
<style>
  .download_img_box{
    background: url('../assets/images/1/qrcode_bg.png') no-repeat;
    background-size: 100% 100%;
  }
</style>
